// Module
var code = "<react-component name=\"SentBulkMessages\"></react-component>\n";
// Exports
module.exports = code;